export default "__VITE_ASSET__DAt_9FuX__"